import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { F as Flex } from '../Flex/Flex-77mGg7gI.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-B_qumqxY.js';
import { H as Heading } from '../Heading/Heading-_71dBU2D.js';

const AlertContent = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40026394__sc-yzbhft-0"
})(["flex:1 0 0;min-height:", ";", ";"], ({
  theme
}) => theme.font.lineHeight.text.base.default, isMobile(css(["min-height:", ";"], ({
  theme
}) => theme.font.lineHeight.text.base.mobile)));
AlertContent.displayName = 'AlertContent';
const AlertHeading = /*#__PURE__*/styled(Heading).withConfig({
  componentId: "sc-storm-ui-40026394__sc-yzbhft-1"
})(["margin-block-end:", ";", ""], ({
  theme
}) => theme.controls.headerGap.default, isMobile(css(["margin-block-end:", ";"], ({
  theme
}) => theme.controls.headerGap.mobile)));
AlertHeading.displayName = 'AlertHeading';
const AlertWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-yzbhft-2"
})(["align-items:flex-start;box-sizing:border-box;border-radius:", ";border:", ";border-inline-start-width:", ";background:", ";font:", ";color:", ";display:flex;overflow-wrap:break-word;padding:", ";word-wrap:break-word;word-break:break-word;", ""], ({
  theme
}) => theme.border.radius.small, ({
  theme,
  $variant
}) => theme.support.border[$variant], ({
  theme
}) => theme.border.width.accent, ({
  theme,
  $variant
}) => theme.support.backgroundColor[$variant], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.spacing.small.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
AlertWrapper.displayName = 'AlertWrapper';
const AlertIconWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40026394__sc-yzbhft-3"
})(["color:", ";display:flex;justify-content:center;align-items:center;margin-inline-end:", ";", ";"], ({
  theme,
  $variant
}) => theme.support.iconColor[$variant], ({
  theme
}) => theme.controls.paddingInline.xlarge.default, ({
  theme,
  withHeader
}) => css(["min-height:", ";", ";"], withHeader ? theme.font.lineHeight.display.medium.default : theme.font.lineHeight.text.base.default, isMobile(css(["min-height:", ";"], withHeader ? theme.font.lineHeight.display.medium.mobile : theme.font.lineHeight.display.base.mobile))));
AlertIconWrapper.displayName = 'AlertIconWrapper';
const StyledCloseButton = /*#__PURE__*/styled(CloseButton).withConfig({
  componentId: "sc-storm-ui-40026394__sc-yzbhft-4"
})(["", ";"], ({
  theme,
  withHeader
}) => css(["min-height:", ";", ";"], withHeader ? theme.font.lineHeight.display.medium.default : theme.font.lineHeight.text.base.default, isMobile(css(["height:", ";"], withHeader ? theme.font.lineHeight.display.medium.mobile : theme.font.lineHeight.text.base.mobile))));

export { AlertWrapper as A, StyledCloseButton as S, AlertIconWrapper as a, AlertContent as b, AlertHeading as c };
//# sourceMappingURL=Alert.styles-5nrxlAqt.js.map
